/**
 * EmployeeFileService
 * Service for EmployeeFile entity operations
 * Route: api/employeefiles
 */
import { CrudService } from '../base/CrudService';
/**
 * EmployeeFileService
 * Handles employee file CRUD operations
 */
export class EmployeeFileService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? EmployeeFileService.DEFAULT_SERVICE_PATH,
            basePath: EmployeeFileService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
}
EmployeeFileService.DEFAULT_SERVICE_PATH = 'hr';
EmployeeFileService.BASE_PATH = 'api/employeefiles';
//# sourceMappingURL=EmployeeFileService.js.map